import { InputSwitch } from "primereact/inputswitch";
import React, { useState } from "react";
import { updateMapWarehouseWithStore } from "../../../services/warehouse/WarehouseWithStore";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import { Checkbox } from "primereact/checkbox";
import { postWarehouseProcessStageSwap } from "../../../services/WarehouseStage/WarehouseStage";

const WarehouseProcessStageSwapModal = ({
  warehouseProcessStageSwapModalVisible,
  setWarehouseProcessStageSwapModalVisible,
  sendDataToWarehouseStageModal,
  warehouseId,
  selectedItemValue,
  warehouseStageData,
}) => {
  const processStageSwapData = warehouseStageData?.filter(
    (item) => item?.stage !== selectedItemValue?.stage // Assuming you are filtering based on 'stage'
  );
  const [selectedSwapData, setSelectedSwapData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleSwapDataToggle = (item) => {
    const updatedSwapData = [item];
    setSelectedSwapData(updatedSwapData);
  };
  const handleDataSubmit = () => {
    const updatedData = {
      firstStageId: selectedItemValue?.id,
      secondStageId: selectedSwapData[0].id,
    };

    postWarehouseProcessStageSwap(warehouseId, updatedData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            setWarehouseProcessStageSwapModalVisible(false);
            sendDataToWarehouseStageModal({
              success: true,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus("success");
              setModalText(message);
            } else {
              setModalVisible(true);
              setModalStatus("not Success");
              setModalText(message);
            }
            setSelectedSwapData([]);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleModalClose = () => {
    setWarehouseProcessStageSwapModalVisible(false);
    setSelectedSwapData([]);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={warehouseProcessStageSwapModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!warehouseProcessStageSwapModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
             <div></div>

              <p className=" text-4xl text-primary-50 font-semibold">
                SWAP PRIORITY
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
                <div className="flex ">
                  <p className="flex-1">Name</p>
                  <p className="flex-1">Priority</p>
                  <p className="">Action</p>
                </div>
                <div>
                  <div
                    className=" flex my-1 mx-1 p-2 border-round-md shadow-4"
                    style={{
                      borderRadius: 5,
                      backgroundImage:
                        "radial-gradient(circle at left top, #4A5D23, #ACE1AF)",
                      flex: 1,
                    }}
                  >
                    <p className="flex-1 text-lg" style={{color:"white"}}>{selectedItemValue?.stage}</p>
                    <p className="flex-1 text-lg" style={{color:"white"}}>{selectedItemValue?.priority}</p>
                    <Checkbox checked={true} color={"#00A3FF"} size={15} />
                  </div>
                </div>
                <div className="flex justify-content-center gap-4 my-2">
                  <i
                    className="pi pi-arrow-up"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#FEBE10",
                    }}
                  ></i>

                  <p>Swap</p>
                  <i
                    className="pi pi-arrow-down"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#4A5D23",
                    }}
                  ></i>
                </div>
                {processStageSwapData?.length > 0 ? (
                  processStageSwapData?.map((item) => (
                    <div key={item.priority}>
                      <div
                        className=" flex my-1 mx-1 p-2 border-round-md shadow-4"
                        key={item.id}
                        style={{
                          borderRadius: 5,
                          backgroundImage:
                            "radial-gradient(circle at left top, #FEBE10, #FFFF00)",
                          flex: 1,
                        }}
                      >
                        <p className="flex-1 text-lg">{item.stage}</p>
                        <p className="flex-1 text-lg">{item.priority}</p>
                        <Checkbox
                          checked={selectedSwapData.includes(item)}
                          color={
                            selectedSwapData.includes(item) ? "#00A3FF" : "#000"
                          }
                          onClick={() => handleSwapDataToggle(item)}
                          size={25}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <p className="text-xl font-medium">No Store Data Found</p>
                  </div>
                )}
              </div>
            </div>

            {processStageSwapData?.length !== 0 && (
              <div className="flex ">
                <Button
                  onClick={handleDataSubmit}
                  className="mb-3 mx-4 border-round-xl w-full"
                  disabled={selectedSwapData?.length <= 0 && true}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                    UPDATE
                  </p>
                </Button>
              </div>
            )}
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default WarehouseProcessStageSwapModal;
